import { RootState } from 'redux/reducers';

export const selectSelfBootstrap = (state: RootState) => state.bootstrap;
export const selectSelfSteelDivide = (state: RootState) => state.steelDivide;
export const selectSelfPlateCutting = (state: RootState) => state.plateCutting;
